<template>
  <div class="home relative h-full">
    <DoneOverview
      v-if="store?.state?.OrderStore?.done.length"
      :orders="store?.state?.OrderStore?.done"
    ></DoneOverview>
    <div class="absolute z-1 inset-0 flex items-center justify-center" v-else>
      <span class="text-gray-500 w-40">{{ $t("order.empty") }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref } from "vue";
import DoneOverview from "@/components/done/DoneOverview.vue";
import { useStore } from "vuex";
import { reAuthorize } from "@/services/auth/re-auth";

export default defineComponent({
  name: "DoneView",
  setup() {
    const store = useStore();
    const startFetchingOrders = () => {
      store.dispatch("OrderStore/getDone");

      const intervalId = setInterval(() => {
        store.dispatch("OrderStore/getDone");
      }, 60000);

      return intervalId;
    };

    let fetchOrdersInterval = 0 as number;

    onMounted(() => {
      reAuthorize(store).then((res) => {
        fetchOrdersInterval = startFetchingOrders();
      });
    });

    onBeforeUnmount(() => {
      clearInterval(fetchOrdersInterval);
    });

    return {
      store,
    };
  },
  components: { DoneOverview },
});
</script>
